import FJUploadButtonContainer from './container/FJUploadButtonContainer.jsx';
import FJLanguageSelectContainer from './container/FJLanguageSelectContainer.jsx';
import FJGenerateButtonContainer from './container/FJGenerateButtonContainer.jsx';
import { useSelector } from 'react-redux';

const FJUploadPanel = props => {
    const activePanelName = useSelector(state => state.textBasedEditing.activePanelName);
    if (activePanelName !== 'default') return;

    return (
        <>
            <FJUploadButtonContainer />
            <FJLanguageSelectContainer />
            <FJGenerateButtonContainer />
        </>
    );
};

export default FJUploadPanel;
